import React from "react";
import { useNavigate } from "react-router-dom";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Col,
  Row,
} from "reactstrap";
import styles from "./style.module.scss";

const ValidateAccount = props => {
  const navigate = useNavigate();

  return (
    <>    
      <div className={styles.bgContent}>
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" lg="4" md="6">
                <Card className="card-login">
                    <CardHeader>
                      <h3 className="header text-center">Activa tu Cuenta</h3>
                  </CardHeader>
                  <CardBody>
                    <p>
                      <b>
                        Hemos enviado un correo electronico con un enlace para
                        activar tu cuenta
                      </b>
                    </p>                 
                    <Button 
                    color="primary" 
                    block 
                    className="btn-round mb-3" 
                    onClick={() => navigate("/auth/login")}
                    >                        
                        Iniciar Sesion
                    </Button>
                  </CardBody>
                </Card>
            </Col>
          </Row>
        </Container>
      </div>
      </>
    );
}

export default ValidateAccount;
